import clsx from 'clsx'

export function Heading({ className, level = 1, ...props }) {
  let Element = `h${level}`

  return (
    <Element
      {...props}
      className={clsx(className, 'text-2xl font-regular text-zinc-950 sm:text-2xl xs:text-xl dark:text-white')}
    />
  )
}

export function Subheading({ className, level = 2, ...props }) {
  let Element = `h${level}`

  return (
    <Element
      {...props}
      className={clsx(className, 'text-2xl font-regular text-zinc-950 sm:text-2xl dark:text-white')}
    />
  )
}
